import { Flex } from "antd";
import { ReactNode, MouseEvent, FC } from "react";
import ChevronDownIcon from "@/assets/chevron-down.svg?react";
import "./index.less";

export interface MenuItemProps {
  text: string;
  icon: ReactNode;
  to?: string;
  onClick?: (e: MouseEvent) => void;
}

export const MenuItem: FC<MenuItemProps> = ({ icon, text, onClick, to }) => {
  const handleClick = (e: MouseEvent) => {
    if (onClick) {
      onClick(e);
    } else if (to) {
      window.location.href = to;
    }
  };

  return (
    <Flex className="header-menu-item" onClick={handleClick}>
      <Flex className="header-menu-item-text-wrapper" align="center" gap={8}>
        {icon}
        <div className="header-menu-item-text">{text}</div>
      </Flex>
      <ChevronDownIcon className="arrow-icon" />
    </Flex>
  );
};
